import api from "../../../utils/api";

export const createUser = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  const res = await api.post("/users/", payload);
  return res.data;
};

export const readUser = async (public_id) => {
  if (!public_id) throw new Error("Missing or invalid ID for user");
  const res = await api.get(`/users/${public_id}`);
  return res.data;
};

export const readUsers = async (params) => {
  const res = await api.get("/users", { params });
  return res.data;
};

export const updateUser = async (payload) => {
  if (process.env.NODE_ENV === "development") console.log(payload);
  if (!payload.public_id) throw new Error("Missing or invalid ID for user");
  const res = await api.put(`/users/${payload.public_id}`, payload);
  return res.data;
};

export const updateUserPhoto = async ({ item, file }) => {
  console.log(`id ${item.public_id} - file ${file}`);
  const formData = new FormData();
  formData.append("entity_type", "users");
  formData.append("entity_id", item.id);
  formData.append("file", file); // 'id' is already in the URL
  //const res = await api.post(`/users/${item.public_id}/photo`, formData); // No headers here
  //return res.status === 200 ? updateUser({ ...item, image_url: res.data?.image_url }) : res; // If the photo has been uploaded successfully, update image_url and return item
  const res = await api.post(`/files`, formData); // No headers here
  return res.status === 201 ? updateUser({ ...item, photo_id: res.data?.id }) : res; // If the photo has been uploaded successfully, update image_url and return item
};

export const deleteUser = async (public_id) => {
  if (process.env.NODE_ENV === "development") console.log(public_id);
  if (!public_id) throw new Error("Invalid ID for user!");
  return await api.delete(`/users/${public_id}`);
};

// Fetch a user's photo and return a blob URL that can be used in <img src> or Avatar.
// Caller is responsible for revoking the URL via URL.revokeObjectURL when no longer needed.
export const readUserPhotoBlobUrl = async (public_id) => {
  if (!public_id) throw new Error("Invalid ID for user!");
  const res = await api.get(`/users/${public_id}/photo`, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  return blobUrl;
};
